<template>
  <div style="padding: 10px;height: 100vh" class="border-box">
    <FullPath></FullPath>
    <div class="uk-flex" style="height: calc(100% - 50px)">
      <LeftSize @onSelect="onSelect"></LeftSize>
      <ProbeInfo
        ref="probeInfo"
        @probeChange="probeChange"
        @otherProbeChange="otherProbeChange"
        @showBuffer="showBuffer"
        :carrier-info="carrierInfo"
        :minMax="minMax"
        :time-range="timeRange"
      ></ProbeInfo>
      <div
        class=" pd-10 ml-5 border"
        style="width: calc(100% - 540px)"
        v-if="transInfo"
      >
        <!--        <div>-->
        <!--          {{ $timetransition(transInfo.start_time) }} ~-->
        <!--          {{ $timetransition(transInfo.end_time) }}-->
        <!--        </div>-->
        <!--        <EchartTab-->
        <!--          style="margin-top: 25px"-->
        <!--          @unitChange="unitChange"-->
        <!--          :tabs="tabs"-->
        <!--        />-->
        <!--        <EchartContent-->
        <!--          :echartObj="echartObj"-->
        <!--          :loading="isRenderChart"-->
        <!--          :unitObj="unitObj"-->
        <!--        ></EchartContent>-->

        <LineChart
          v-loading="isRenderChart"
          class="uk-margin-small-bottom"
          :min-max="minMax"
          ref="lineChart"
          :probe="$refs.probeInfo.form.probe"
        ></LineChart>
        <!--        <MaxMin :listObj="listObj" :unitObj="unitObj"></MaxMin>-->
        <el-table
          :data="tableData"
          stripe
          v-loading="loading"
          ref="multipleTable"
          tooltip-effect="dark"
          style="width: 100%"
          :header-cell-style="headCellStyle"
          :height="'calc(100% - 450px)'"
          :row-style="{ height: '35px' }"
        >
          <el-table-column :label="$t('integration.equipment')" prop="no">
            <template #default="{ row }">
              <i
                v-icon:theme="['sensorTypeConvert', $route.query.deviceType]"
              ></i>
              {{ row.no }}
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('integration.acquisition_time')"
            prop="collectTime"
          >
            <template #default="{ row }">
              {{ $timetransition(row.collectTime) }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('integration.collect_data')" prop="val">
            <template #default="{ row }">
              <span v-range="[row.val, row]">
                {{ row.val }} {{ unitObj.unit }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('integration.monitoring_interval')"
            prop="min"
          >
            <template #default="{ row }">
              <template v-if="row.min !== undefined">
                {{ row.min }}{{ unitObj.unit }} ~ {{ row.max
                }}{{ unitObj.unit }}
              </template>
              <template v-else>
                {{ $t('integration.no_monitoring_interval') }}
              </template>
            </template>
          </el-table-column>
        </el-table>
        <Pager
          ref="pagination"
          :total="total"
          :size="SearchForm.iDisplayLength"
          @currentChange="currentChange"
        ></Pager>
      </div>
      <div class="uk-flex-1 pd-10 ml-5 border" v-else>
        <el-empty :description="$t('请选择运输记录')"></el-empty>
      </div>
    </div>
  </div>
</template>

<script>
import FullPath from '@/pages/business/win/ProbeHistory/components/FullPath.vue'
import LeftSize from './components/LeftSide.vue'
import EchartContent from '@/pages/equipment/sensor/echart/EchartContent.vue'
import MaxMin from '@/pages/equipment/sensor/echart/MaxMin.vue'
import EchartTab from '@/pages/equipment/sensor/echart/EchartTab.vue'
import { carrierRelectList, probeHisotry } from '@/api/modules/carrier'
import { isTimeExceedThreshold } from '@/utils/time'
import Pager from '@/components/Pagination/src/Pager.vue'
import store from '@/store'
import { isSensor,  isSensor2} from '@/utils/sensor/sensorUtil'
import ProbeInfo from '@/pages/business/win/TransportHistory/components/ProbeInfo.vue'
import LineChart from '@/components/Charts/LineChart.vue'
import { calcSeries, processToken } from '@/utils/chartDataProcess'
import { markLine } from '@/components/Charts/schema/LineChartSchema'

export default {
  components: {
    LineChart,
    ProbeInfo,
    Pager,
    EchartTab,
    MaxMin,
    EchartContent,
    FullPath,
    LeftSize
  },
  data () {
    return {
      /**
       * 最大最小值
       */
      minMax: {
        min: null,
        max: null,
        avg: null,
        ex: null,
        store: null
      },
      isRenderChart: false,
      timeoutFlag: 0,
      unitObj: {},
      // 温度
      unitArray: [
        {
          key: 'temp',
          unit: "store.state.unit['temp'].name",
          yText: `温度(${"store.state.unit['temp'].name"})`
        },
        {
          key: 'hum',
          unit: "store.state.unit['hum'].name",
          yText: `湿度(${"store.state.unit['hum'].name"})`
        }
      ],
      probeList: [],
      // 运输信息
      transInfo: null,
      tableData: [],
      total: 0,
      listObj: {},
      loading: false,
      tabs: ['temp', 'hum'],
      SearchForm: {
        code: '',
        carrierId: 0,
        time: '',
        isEx: '',
        isStore: '',
        dataSort: 0,
        pageSort: 1,
        devCatalog: 0,
        block: 1,
        probe: 'temp',
        token: null,
        iDisplayStart: 0,
        iDisplayLength: 5,
        from: undefined,
        to: undefined
      },
      // echart 数据  必须分离 否则 造成页面渲染缓慢以及卡顿
      echartObj: {
        min: '',
        max: '',
        data: [],
        rangeData: []
      }
    }
  },

  mounted () {
    this.updateUnit()
  },
  computed: {
    carrierInfo () {
      const { carrierType, carrierId } = this.$route.query
      return {
        carrierId,
        carrierType
      }
    },
    timeRange () {
      return {
        start: this.SearchForm.from,
        end: this.SearchForm.to
      }
    }
  },

  methods: {
    /**
     * 展示缓冲区间
     */
    showBuffer (range, status) {
      const options = this.$refs.lineChart.getOption()
      if (status) {
        options.series[0].markLine = markLine(range.min, range.max)
      } else {
        options.series[0].markLine = {}
      }
      this.$refs.lineChart.setOption(options)
    },
    otherProbeChange (compare, code) {
      const options = this.$refs.lineChart.getOption()
      if (!code) {
        compare.push(this.$refs.probeInfo.form.code)

        options.series = options.series.filter(
          item => compare.indexOf(item.code) !== -1
        )
        this.$refs.lineChart.setOption(options)
        return
      }
      this.SearchForm.code = code
      this.SearchForm.token = null

      processToken(probeHisotry, this.SearchForm, result => {
        result.data = result.data.map(item => {
          item.time = item.collectTime
          return item
        })

        const opt = calcSeries(result.data, {}, this.$refs.probeInfo.form.probe)
        if (opt.series.length) {
          opt.series[0].code = code
          options.series.push(opt.series[0])
          if (!this.SearchForm.token) {
            this.$refs.lineChart.setOption(options)
          }
        }
      })
    },
    /**
     * 温度计选择改变
     * @param form  表单项
     * @param selectedCode  已选择的code
     */
    probeChange (form, selectedCode) {
      this.SearchForm = { ...this.SearchForm, ...form }
      this.isRenderChart = true
      this.SearchForm.token = null

      if (this.timeRange.start && this.timeRange.end) {
        this.getListFn()
      }
    },
    updateUnit () {
      this.unitArray[0] = {
        key: 'temp',
        unit: store.state.unit.temp.name,
        yText: `温度(${store.state.unit.temp.name})`
      }
      this.unitArray[1] = {
        key: 'hum',
        unit: store.state.unit.hum.name,
        yText: `湿度(${store.state.unit.hum.name})`
      }
      if (!Object.keys(this.unitObj).length) {
        this.unitObj = this.unitArray[0]
      }
    },

    currentChange ({ iDisplayStart, iDisplayLength }) {
      this.SearchForm.iDisplayStart = iDisplayStart
      this.SearchForm.iDisplayLength = iDisplayLength
      this.getListFn()
    },
    getProbeList () {
      const { carrierType, carrierId } = this.$route.query
      this.SearchForm.carrierId = carrierId

      carrierRelectList(carrierType, carrierId).then(({ result }) => {
        // this.probeList = result.filter(item => isSensor(item))
        this.probeList = result.filter(item => isSensor2(item))

        if (this.probeList.length) {
          this.SearchForm.code = this.probeList[0].code
        }
      })
    },
    onSelect (data) {
      this.$refs.probeInfo.clearCompare()

      this.SearchForm.token = ''
      this.transInfo = data
      this.SearchForm.from = data.startTime
      this.SearchForm.to = data.endTime
      this.isRenderChart = true
      this.getListFn()
    },
    getListFn () {
      processToken(probeHisotry, this.SearchForm, result => {
        if (!result.data.length) {
          this.loading = false
          this.isRenderChart = false
          this.tableData = []
          this.$refs.lineChart.setOption({})
          return this.$message.warning($t("integration.no_data_temporarily"))
        }
        this.minMax.min = result.minVal
        this.minMax.max = result.maxVal
        this.minMax.avg = result.avgVal
        this.minMax.ex = 0
        this.minMax.store = 0
        result.data = result.data.map(item => {
          if (item.isStore) {
            this.minMax.store += 1
          }
          if (item.isEx) {
            this.minMax.ex += 1
          }

          item.time = item.collectTime
          return item
        })
        const options = calcSeries(
          result.data,
          {},
          this.$refs.probeInfo.form.probe
        )
        if (options.series.length) {
          options.series[0].code = this.SearchForm.code
        }

        const { pageInfo, result: pageResult } = result.page
        this.tableData = pageResult
        this.total = pageInfo.total
        this.listObj = result
        if (result.dafaultForm) {
          this.SearchForm.from = result.dafaultForm
          this.SearchForm.to = result.dafaultTo
          this.SearchForm.time = [
            this.$timetransition(result.dafaultForm),
            this.$timetransition(result.dafaultTo)
          ]
        }

        if (this.isRenderChart) {
          this.$refs.lineChart.setOption(options)
          this.isRenderChart = false
        }
      })
      return
      this.loading = true
      clearTimeout(this.timeoutFlag)
      // if (this.SearchForm.time) {
      //   this.SearchForm.from = new Date(this.SearchForm.time[0]).getTime()
      //   this.SearchForm.to = new Date(this.SearchForm.time[1]).getTime()
      // }

      if (isTimeExceedThreshold(this.SearchForm.from, this.SearchForm.to)) {
        this.SearchForm.block = 0
      } else {
        this.SearchForm.block = 1
      }
      // delete this.SearchForm.time;
      probeHisotry(this.SearchForm).then(({ result }) => {
        if (!result) {
          return (this.loading = false)
        }
        // 没有结束 继续轮询
        if (!result.ok) {
          this.SearchForm.token = result.token
          this.timeoutFlag = setTimeout(() => {
            this.getListFn()
          }, 1000)
          return
        } else {
          if (result.token) {
            this.SearchForm.token = result.token
          }
          this.loading = false
        }

        // 第一页的时候才渲染echart
        if (this.isRenderChart) {
          this.isRenderChart = false
          console.log('probe:进入渲染流程')

          // this.echartObj = {
          //   max: result.max,
          //   min: result.min,
          //   data: result.data,
          //   rangeData: result.rangeData || []
          // }
        }
      })
    },

    unitChange (name) {
      this.unitArray.forEach(item => {
        if (name === item.key) {
          this.unitObj = item
        }
      })
      this.SearchForm.probe = name

      this.SearchForm.token = ''

      this.isRenderChart = true
      // this.token = null;
      this.count = 0
      this.getListFn('search')
    }
  }
}
</script>

<style lang="scss" scoped>
.el-col {
  margin-bottom: 10px;
}
</style>
